import { ActionContext, Module } from 'vuex'
import { getCityList, getCmsAppConfig } from './city-choose.service'

interface ICityChooseState {
    cityList: any[]
    cmsAppConfig: any
}

export const STORE: Module<ICityChooseState, any> = {
    namespaced: true,
    state: () => ({
        cityList: [],
        cmsAppConfig: undefined
    }),
    mutations: {
        setCityList(state: ICityChooseState, payload: any) {
            state.cityList = payload
        },
        setCmsAppConfig(state: ICityChooseState, payload: any) {
            state.cmsAppConfig = payload
        }
    },
    getters: {},
    actions: {
        async getCityListAction(context: ActionContext<ICityChooseState, any>) {
            const res: ResponseErrno = await getCityList()
            context.commit('setCityList', res)
        },

        async getAppConfigAction(context: ActionContext<ICityChooseState, any>) {
            const res: ResponseCode = await getCmsAppConfig()
            context.commit('setCmsAppConfig', res)
        }
    }
}
